
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPanelItemButtonGrid extends Serenity.EntityGrid<PsPanelItemButtonRow, any> {
        protected getColumnsKey() { return PsPanelItemButtonColumns.columnsKey; }
        protected getDialogType() { return PsPanelItemButtonDialog; }
        protected getIdProperty() { return PsPanelItemButtonRow.idProperty; }
        protected getInsertPermission() { return PsPanelItemButtonRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPanelItemButtonRow.localTextPrefix; }
        protected getService() { return PsPanelItemButtonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        // protected getButtons() {
        //     var buttons = super.getButtons();
            
        //     buttons.push(
        //         {
        //             title: Q.text("Close"), // *** Get button text from translation
        //             cssClass: '.panel-titlebar-close',
        //             icon: 'fa-close',
        //             onClick: () => {
        //                 window.location.href = '/';
        //                 return false;
        //             },
        //         }
        //     );            
        //     return buttons;
        // }
    }
}